export const PLACEHOLDER = Symbol('PLACEHOLDER')

const basePartial = (fn, args) => fn.bind(null, ...args)

const nextPlaceholderIdx = args => args.indexOf(PLACEHOLDER)

export const noop = () => {
}

export const identity = x => x

export const constant = x => () => x

export const isFunction = t => (t ? typeof t === 'function': false)

export const pipe = (first, ...rest) => (...args) =>
  rest.reduce((result, fn) => fn(result), first(...args))

export const compose = (...fns) => pipe(...fns.reverse())

export const nAry = (arity, fn) => {
  if (fn === undefined) return cFn => nAry(arity, cFn)
  return (...args) => fn(...args.slice(0, arity))
}

export const unary = nAry(1)

export const curry = fn => (...args) => {
  if (nextPlaceholderIdx(args) === -1) {
    return args.length >= fn.length ? fn(...args): curry(basePartial(fn, args))
  }
  
  return (...nextArgs) => {
    let newArgs = args.map(v => (v === PLACEHOLDER && nextArgs.length ? nextArgs.shift(): v))
    newArgs = newArgs.concat(nextArgs)
    
    return newArgs.length >= fn.length && nextPlaceholderIdx(newArgs) === -1
      ? fn(...newArgs)
      : curry(fn)(...newArgs)
  }
}

export const partial = curry(basePartial)

export const defer = fn => setTimeout(fn, 0)

export const tap = curry((fn, x) => {
  fn(x)
  return x
})

function shallowRecursively(wrapper, selector) {
  // Do not try to shallow render empty nodes and host elements
  // (a.k.a primitives). Simply return the wrapper in that case.
  if (wrapper.isEmptyRender() || typeof wrapper.getElement().type === 'string') return wrapper
  
  const nextWrapper = wrapper.dive()
  
  return selector && wrapper.is(selector) ? nextWrapper: shallowRecursively(nextWrapper, selector)
}

export function until(selector) {
  return this.single('until', () => shallowRecursively(this, selector))
}

// Invoke an array of functions object that has the blueprint of {func: func, args: []}
export const invokeFuncs = (functions) => {
  if (Array.isArray(functions)) {
    functions.map((funcObj, i) => {
      if (!funcObj) return
      if (Array.isArray(funcObj.args)) {
        funcObj.func.apply(this, funcObj.args)
      } else {
        funcObj.func.call(this, funcObj.args)
      }
    })
  } else {
    console.warn('You did not pass an array to invokeFuncs')
  }
}



// WEBPACK FOOTER //
// ./src/utils/function.js